import { useState, useEffect } from 'react';

const SHIPPING_OPTIONS = {
  dac_montevideo: {
    type: 'dac_montevideo',
    label: 'DAC Montevideo',
    description: 'Entrega a domicilio dentro de Montevideo',
    cost: 150,
    estimatedDays: '1-2 días hábiles',
    icon: 'fa-motorcycle'
  },
  retiro_local: {
    type: 'retiro_local',
    label: 'Retiro en Local',
    description: 'Retira tu pedido en nuestra tienda',
    cost: 0,
    estimatedDays: 'Disponible en 24hs',
    icon: 'fa-store'
  },
  envio_interior: {
    type: 'envio_interior',
    label: 'Envío al Interior',
    description: 'Envío a cualquier departamento del interior',
    cost: 350,
    estimatedDays: '3-5 días hábiles',
    icon: 'fa-truck'
  }
};

const ShippingSelector = ({ selectedShipping, onShippingChange, ciudad }) => {
  const [selected, setSelected] = useState(selectedShipping || 'retiro_local');

  useEffect(() => {
    // Si la ciudad es Montevideo, sugerir DAC
    if (ciudad && ciudad.toLowerCase().includes('montevideo') && !selectedShipping) {
      setSelected('dac_montevideo');
      onShippingChange(SHIPPING_OPTIONS.dac_montevideo);
    }
  }, [ciudad]);

  useEffect(() => {
    // Notificar al padre cuando cambia la selección
    if (selected && SHIPPING_OPTIONS[selected]) {
      onShippingChange(SHIPPING_OPTIONS[selected]);
    }
  }, [selected]);

  const handleSelect = (type) => {
    setSelected(type);
    onShippingChange(SHIPPING_OPTIONS[type]);
  };

  return (
    <div className="shipping-selector">
      
      <div className="shipping-options">
        {Object.entries(SHIPPING_OPTIONS).map(([key, option]) => (
          <div 
            key={key}
            className={`shipping-option ${selected === key ? 'selected' : ''}`}
            onClick={() => handleSelect(key)}
          >
            <div className="shipping-option-content">
              <div className="shipping-icon">
                <i className={`fa-solid ${option.icon}`}></i>
              </div>
              <div className="shipping-details">
                <div className="shipping-label">{option.label}</div>
                <div className="shipping-description">{option.description}</div>
                <div className="shipping-time">
                  <i className="fa-regular fa-clock me-1"></i>
                  {option.estimatedDays}
                </div>
              </div>
              <div className="shipping-price">
                {option.cost === 0 ? (
                  <span className="free-badge">GRATIS</span>
                ) : (
                  <span className="price">${option.cost}</span>
                )}
              </div>
              <div className="shipping-check">
                {selected === key && <i className="fa-solid fa-circle-check"></i>}
              </div>
            </div>
          </div>
        ))}
      </div>

      <style jsx="true">{`
        .shipping-selector {
          padding: 0;
        }

        .shipping-options {
          display: flex;
          flex-direction: column;
          gap: 0;
        }

        .shipping-option {
          border: none;
          border-bottom: 1px solid var(--border-light, #eee);
          padding: 16px 24px;
          cursor: pointer;
          transition: all 0.2s ease;
          background: var(--bg-white, #fff);
          border-radius: 0;
        }

        .shipping-option:last-child {
          border-bottom: none;
        }

        .shipping-option:hover {
          background: var(--bg-secondary, #fafafa);
        }

        .shipping-option.selected {
          background: var(--bg-secondary, #fafafa);
          border-left: 3px solid var(--brand-primary, #1a1a1a);
          box-shadow: none;
        }

        .shipping-option-content {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .shipping-icon {
          width: 40px;
          height: 40px;
          border-radius: 0;
          background: var(--bg-secondary, #f5f5f5);
          border: 1px solid var(--border-light, #eee);
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--text-primary, #1a1a1a);
          font-size: 0.95rem;
          flex-shrink: 0;
        }

        .shipping-option.selected .shipping-icon {
          background: var(--brand-primary, #1a1a1a);
          color: var(--text-inverse, #fff);
          border-color: var(--brand-primary, #1a1a1a);
        }

        .shipping-details {
          flex: 1;
        }

        .shipping-label {
          font-weight: 600;
          font-size: 0.85rem;
          color: var(--text-primary, #1a1a1a);
          margin-bottom: 2px;
          letter-spacing: 0.02em;
        }

        .shipping-description {
          font-size: 0.78rem;
          color: var(--text-muted, #999);
          margin-bottom: 2px;
        }

        .shipping-time {
          font-size: 0.72rem;
          color: var(--text-muted, #999);
          letter-spacing: 0.02em;
        }

        .shipping-price {
          text-align: right;
          min-width: 70px;
          width: 70px;
          flex-shrink: 0;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }

        .shipping-price .price {
          font-size: 1.05rem;
          font-weight: 600;
          color: var(--text-primary, #1a1a1a);
          letter-spacing: -0.02em;
        }

        .shipping-price .free-badge {
          background: var(--brand-primary, #1a1a1a);
          color: var(--text-inverse, #fff);
          padding: 4px 10px;
          border-radius: 0;
          font-size: 0.68rem;
          font-weight: 600;
          letter-spacing: 0.08em;
          white-space: nowrap;
          text-transform: uppercase;
        }

        .shipping-check {
          width: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .shipping-check i {
          color: var(--brand-primary, #1a1a1a);
          font-size: 1.1rem;
        }

        @media (max-width: 576px) {
          .shipping-option {
            padding: 14px 16px;
            position: relative;
          }
          
          .shipping-option-content {
            flex-wrap: nowrap;
            align-items: center;
          }

          .shipping-icon {
            width: 32px;
            height: 32px;
            font-size: 0.8rem;
          }

          .shipping-details {
            flex: 1;
            min-width: 0;
          }

          .shipping-label {
            font-size: 0.8rem;
          }

          .shipping-description {
            font-size: 0.7rem;
          }

          .shipping-time {
            font-size: 0.65rem;
          }

          .shipping-price {
            min-width: 55px;
            width: auto;
          }

          .shipping-price .price {
            font-size: 0.9rem;
          }

          .shipping-price .free-badge {
            font-size: 0.6rem;
            padding: 3px 8px;
          }

          .shipping-check {
            width: 18px;
          }

          .shipping-check i {
            font-size: 0.95rem;
          }
        }
      `}</style>
    </div>
  );
};

export default ShippingSelector;
